export default {
  get_domain_id: state => state.domain_id,
  domainQueue: state => state.domainQueue,
  domain: state => {
    return { ...state.domainCache.filter(x => {
      if (x.id === state.domain_id) {
        return x
      }
    })[0] }
  },
  domainPopulated: state => {
    return state.domainCache.filter(x => {
      if (x.id === state.domain_id) {
        return x
      }
    }).length
  },
  domainCache: state => state.domainCache,
  getDomainsTransferList: state => state.domainsTransferList,
  domainChangeRequests: state => new Map(state.domainChangeRequests),
}
